var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownBlueCarets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carets Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.43557 8.35494L1.83839 4.24388C1.41407 3.75894 1.75846 3 2.40283 3H9.59717C10.2415 3 10.5859 3.75894 10.1616 4.24388L6.56443 8.35493C6.26562 8.69643 5.73438 8.69643 5.43557 8.35494Z",
    fill: "#0923E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBlueCarets);
export default __webpack_public_path__ + "static/media/dropdown-blue-carets.8f1dbf5a19231f605c6b9b0e553043d3.svg";
export { ForwardRef as ReactComponent };